// main.js

function Main() {};
Main.prototype = {
	constructor: Main,

	/** Init Functions **********/
	initPlugins: function (context, overlay)  {

		if(!overlay) {

			$('.hero').each(function(){
				new hero($(this)).init();
			});

			$('.history__timeline').each(function(){
				new history($(this)).init();
			});

			$('.news').each(function(){
				new news($(this)).init();
			});

			$('.testimonials').each(function(){
				new testimonials($(this)).init();
			});

			$('.lifestyle').each(function(){
				new lifestyle($(this)).init();
			});

			$('.team').each(function(){
				new team($(this)).init();
			});

			$('.events').each(function(){
				new events($(this)).init();
			});

			$('.social__hub').each(function(){
				new socialhub($(this)).init();
			});

			$('.media').each(function(){
				new media($(this)).init();
			});

			$('.js-ct-gallery').each(function(){
				new content($(this)).init();
			});

		} else {

			context.find('.js-ct-gallery').each(function(){
				new content($(this)).init();
			});

			context.find('.js-audioplayer').audioPlayer({
				strPlay: '',
				strPause: '',
				strVolume: 'Volume'
			});
		}

	},
	init: function(){
		Main.initPlugins($('body'), false);
	}

}

// page done loading execute JS for all blocks
var Main = new Main();

function pageLoaded(){
	$(Main.init);
}

// scrolling mainnavigation
$(document).ready(function(){

	$('.js-nav-trigger').each(function(){
		new nav($(this)).init();
	});

	new cookiheader().init();

	$(document).on('click','.page__navigation .scroll',function(e){
		var $link = $(this);
		var go_to = $link.attr('data-goto');
		console.log(go_to);

		$('.block_container .block_to_take').each(function(){
			var $block = $(this);
			if($block.attr('data-route') == go_to){
				var pos = $block.offset().top;
				pos = pos - $('.page__header').height();
				console.log(pos);
				$('html,body').animate({ scrollTop: pos }, 1000, 'easeInOutCubic');
			}
		});

		e.preventDefault();
	});
});

// highlighting menu
/*
$(document).ready(function(){
    var aChildren = $(".menu--main a.scroll");
    var aArray = [];
    for (var i=0; i < aChildren.length; i++) {
        var aChild = aChildren[i];
        var ahref = $(aChild).attr('data-goto');
        aArray.push(ahref);
    }

    $(window).scroll(function(){
        var windowPos = $(window).scrollTop();
        var windowHeight = $(window).height();
        var docHeight = $(document).height();

        for (var i=0; i < aArray.length; i++) {
            var theID = aArray[i];
            var divPos = $('.block_to_take[data-route="' + theID + '"]').offset().top;
            var divHeight = $('.block_to_take[data-route="' + theID + '"]').height();
            if (windowPos >= divPos && windowPos < (divPos + divHeight)) {
                $("a[data-goto='" + theID + "']").addClass("nav-active");
            } else {
                $("a[data-goto='" + theID + "']").removeClass("nav-active");
            }
        }

        if(windowPos + windowHeight == docHeight) {
            if (!$(".navigation_list li:last-child a").hasClass("nav-active")) {
                var navActiveCurrent = $(".nav-active").attr("data-goto");
                $("a[data-goto='" + navActiveCurrent + "']").removeClass("nav-active");
                $(".navigation_list li:last-child a").addClass("nav-active");
            }
        }
    });
});
*/




/* HISTORY
********************/
var protocol = window.location.href.split('://').shift()+'://';
var rootDir = protocol + window.location.host;
var manualStateChange = true;

var ovlUrls = ['news'];

(function(window,undefined){

	var
	History 	= window.History,
	State 		= History.getState();

	History.options.debug = false;

	History.setTitle = function(){};

	// Bind to State Change
	History.Adapter.bind(window,'statechange',function(){

		// Log the State
		var State = History.getState(), path;

		if(History.savedStates.length == 2 && $('html').hasClass('lt-ie10') && window.location.href.indexOf('?&_suid') > -1){
			window.location.href = State.url;
		}

		if(manualStateChange == true){
			checkTask(History.getState().url);
		}
		manualStateChange = true;

		if(State.data['url']){
			path = State.data['url'].split('/');
			if(path[path.length-1] == "") path.pop();
		}

	});

})(window);

// CHECK WHAT TO DO WITH URL
function checkTask(url){
	var path = url.replace(rootDir+'/','');
	var path_split = path.split('/');

	// check if open / close ovl
	for(var i=0;i<ovlUrls.length;i++){
		if(ovlUrls[i] == path_split[1]){
			if(path_split.length > 2 && path_split[2].length > 1){
				openOverlay(url);
			} else {
				$('#overlay_close').trigger('click');
			}
		}
	}
}

/* HISTORY NAV FOR OVERLAYS
********************/
$(document).ready(function(){

	$(document).on('click','.js-overlay-open',function(e){
		var $this = $(this);

		if($this.attr('data-overlay-type') == 'news') {
			// trigger this function if you want this to be a deeplink
			setNav($this.attr('href'), $this.attr('title'), 'openOvl');
		}

		e.preventDefault();
	});

});

function setNav(href,title,type){
	var url 	= href,
	title 	= title ? title : false;

	manualStateChange = false;
	History.pushState({url: url, type: type}, title, "" + url);
}

// OPEN OVERLAY
var scroll_position = 0;
function openOverlay(url){

	// fade in div to block ui
	$('#overlay').fadeIn();

	// fix background (main site)
	scroll_position = $(window).scrollTop();
	$container.css({
		position:'fixed',
		marginTop:'-' + scroll_position + 'px',
	});

	// load overlay content
	$.ajax({
		url:url,
		type:'post',
		success:function(data){
			$data = $(data).filter('#overlay_content');
			$('body').prepend($data);
		}
	});

}

// CLOSE OVERLAY
var ovl_content_clicked = false;
$(document).ready(function(){
	// close ovl on close button
	$(document).on('click','#overlay_close',function(e){
		closeOverlay($(this));
		e.preventDefault();
	});
	// prevent closing overlay when ovl content is clicked
	$(document).on('click','#overlay_content',function(){
		ovl_content_clicked = true;
		setTimeout("ovl_content_clicked = false;",100);
	});
	// close ovl on ovl background
	$(document).on('click','#overlay',function(){
		if(!ovl_content_clicked) $('#overlay_close').trigger('click');
		else ovl_content_clicked = false;
	});
});
function closeOverlay($close){
	setNav($close.attr('href'),$close.attr('title'),'closeOvl');

	$('#overlay_content').fadeOut(function(){ $(this).remove(); });
	$('#overlay').fadeOut();

	// fix background (main site)
	$container.css({
		position:'relative',
		marginTop:'0'
	});
	$(window).scrollTop(scroll_position);
}
